import { normalizeMarkerUser } from '@/helpers/UserMarkerHelper'

const readIdFromIri = value => {
	if (!value || typeof value !== 'string') return null
	const parts = value.split('/')
	const id = Number(parts[parts.length - 1])
	return Number.isFinite(id) ? id : null
}

const readId = value => {
	if (value == null) return null
	if (typeof value === 'number') return value
	if (typeof value === 'string' && /^\d+$/.test(value)) return Number(value)
	if (typeof value === 'object' && value.id != null) return Number(value.id)
	return readIdFromIri(value)
}

const toNumberOrNull = value => {
	if (value === null || value === undefined || value === '') return null
	const number = Number(String(value).replace(',', '.'))
	return Number.isFinite(number) ? number : null
}

const firstDefined = (...values) => values.find(value => value !== null && value !== undefined && value !== '')

const compact = values => values.filter(value => value !== null && value !== undefined && value !== '')

const buildAddress = source => {
	if (!source || typeof source !== 'object') return ''

	const readyAddress = firstDefined(
		source.address,
		source.fullAddress,
		source.clientAddress
	)

	if (readyAddress) return String(readyAddress).trim()

	const cityLine = compact([source.postalCode, source.city || source.post]).join(' ')
	const streetLine = compact([source.street]).join(' ')
	const stateLine = source.state ? `woj. ${source.state}` : ''

	return compact([cityLine, streetLine, stateLine]).join(', ')
}

const getCreator = source => {
	if (!source || !source.creator) return null
	if (typeof source.creator === 'object') return normalizeMarkerUser(source.creator)
	const id = readIdFromIri(source.creator)
	return id ? normalizeMarkerUser({ id }) : null
}

const normalizeOrder = order => {
	const source = order || {}
	const id = readId(source)
	const latitude = toNumberOrNull(firstDefined(source.lat, source.latitude))
	const longitude = toNumberOrNull(firstDefined(source.lon, source.longitude))

	return {
		key: `order:${id}`,
		id,
		type: 'order',
		name: source.clientName || `Zamówienie #${id}`,
		address: buildAddress(source),
		latitude,
		longitude,
		creator: getCreator(source),
		routeColor: source.route && source.route.color ? source.route.color : null,
		isPermanent: false,
		hasCoordinates: latitude !== null && longitude !== null,
		source
	}
}

const normalizePermanentPoint = point => {
	const source = point || {}
	const id = readId(source)
	const latitude = toNumberOrNull(firstDefined(source.lat, source.latitude))
	const longitude = toNumberOrNull(firstDefined(source.lon, source.longitude))

	return {
		key: `permanentPoint:${id}`,
		id,
		type: 'permanentPoint',
		name: source.name || `Punkt stały #${id}`,
		address: buildAddress(source),
		description: source.description || '',
		latitude,
		longitude,
		creator: getCreator(source),
		routeColor: null,
		isPermanent: true,
		hasCoordinates: latitude !== null && longitude !== null,
		source
	}
}

const normalizeCollection = data => {
	if (!data) return []
	if (Array.isArray(data)) return data
	if (Array.isArray(data.member)) return data.member
	if (Array.isArray(data['hydra:member'])) return data['hydra:member']
	if (Array.isArray(data.items)) return data.items
	return []
}

const pointToPlanPayload = point => {
	const payload = {
		type: point.type,
		id: point.id
	}

	if (point.description) payload.description = point.description

	return payload
}

export {
	buildAddress,
	normalizeOrder,
	normalizePermanentPoint,
	normalizeCollection,
	pointToPlanPayload
}
